import BaseFeature from '../../foundation/base/base';

class GtmEcommDetail extends BaseFeature {
	constructor(element) {
		super(element);

		this.element = element;

		this.initDomCache();

		this.data = JSON.parse(element.dataset.click);
		this.anchor = this.dom.anchor;
		this.url = this.anchor.getAttribute('href');
		this.ecommData = {
			event: 'productClick',
			ecommerce: {
				click: {
					actionField: { list: '' },
					products: [{
						name: '',
						id: '',
						price: '',
						brand: '',
						category: '',
						variant: '',
						position: ''
					}]
				}
			},
			eventCallback: '',
			eventTimeout: 250
		};

		this.init();
	}

	init() {
		const ecommDataProduct = this.ecommData.ecommerce.click.products[0];
		ecommDataProduct.name = this.data.name;
		ecommDataProduct.id = this.data.id;
		ecommDataProduct.price = this.data.price;
		ecommDataProduct.brand = this.data.brand;
		ecommDataProduct.category = this.data.category;
		ecommDataProduct.variant = this.data.variant;
		ecommDataProduct.position = this.data.position;

		this.ecommData.ecommerce.click.actionField.list = this.data.list;

		this.ecommData.eventCallback = () => {
			document.location = this.url;
		};

		this.log(this.ecommData);

		this.anchor.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();

			this.log('click');
			this.log(this.ecommData);
			this.push();
		});
	}

	push() {
		if (window.dataLayer) {
			window.dataLayer.push(this.ecommData);
		}
	}
}

export default GtmEcommDetail;
